import React, { useEffect } from 'react'
import DatePicker from '../../LaridaeApp/datepicker/container/DatePicker'
import { obtenerExistenciaDiariaPorVariedad, obtenerExistenciaDiariaPorCereal } from '../actions'
import { connect } from 'react-redux'
import ExistenciaDiariaPorVariedad from '../components/ExistenciaDiariaPorVariedad'
import ExistenciaDiariaPorCereal from '../components/ExistenciaDiariaPorCereal'

function ExistenciaDiaria (props) {
  const { obtenerExistenciaDiariaPorCereal, obtenerExistenciaDiariaPorVariedad } = props

  useEffect(() => {
    obtenerExistenciaDiariaPorCereal(new Date())
    obtenerExistenciaDiariaPorVariedad(new Date())
  }, [obtenerExistenciaDiariaPorCereal, obtenerExistenciaDiariaPorVariedad])

  const actualizarFecha = (fecha) => {
    obtenerExistenciaDiariaPorCereal(fecha)
    obtenerExistenciaDiariaPorVariedad(fecha)
  }

  return (
    <>
      <div className='container-entre-fechas' style={{ margin: '-3% auto 0 auto' }}>
        <DatePicker
          disabledFuture
          locale='es'
          onDateChange={actualizarFecha}
          titulo='Seleccione una fecha'
          value='fechas'
        />
      </div>
      <ExistenciaDiariaPorCereal />
      <ExistenciaDiariaPorVariedad />
    </>
  )
}

const mapActionsToProps = {
  obtenerExistenciaDiariaPorCereal,
  obtenerExistenciaDiariaPorVariedad
}

const withRedux = connect(null, mapActionsToProps)
export default withRedux(ExistenciaDiaria)
